<template>
  <div>
    <h1 class="title">{{ dogData.name | capitalize }} è in salute?</h1>

    <form class="form" @submit.prevent>
      <div class="form-group">
        <div
          class="switch-container"
          :class="[dog.healthy == null ? 'switch-empty' : '']"
        >
          <label
            for="healthy_yes"
            class="switch-option"
            :class="[dog.healthy == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.healthy.$model"
              class="hidden"
              type="radio"
              id="healthy_yes"
              value="1"
            />
            <span>Sì, sta meglio di me</span></label
          >

          <label
            for="healthy_no"
            class="switch-option"
            :class="[dog.healthy == 0 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.healthy.$model"
              class="hidden"
              type="radio"
              id="healthy_no"
              value="0"
            />
            <span>Non proprio</span>
          </label>
        </div>
        <div v-if="$v.dog.healthy.$error" class="error">campo obbligatorio</div>
      </div>

      <div class="form-group" v-if="showNotHealthy">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <label
            :class="[sendEmail == 0 ? 'checked' : 'unchecked']"
            class="option-radio option-icon"
            for="can_go_ahead_yes"
          >
            <input
              v-model.number="$v.sendEmail.$model"
              class="hidden"
              type="radio"
              id="can_go_ahead_yes"
              value="0"
            />
            <div class="text-left">
              <div class="option-label">
                Procedi fino alla scelta della tua pappa
              </div>
              <div class="option-detail">
                ma prima di eseguire il pagamento mostra al tuo veterinario la
                nostra dieta per essere sicuri che sia quella adatta al tuo
                cane.
              </div>
            </div>
          </label>

          <label
            class="option-radio option-icon"
            for="can_go_ahead_no"
            :class="[sendEmail == 1 ? 'checked' : 'unchecked']"
          >
            <input
              v-model.number="$v.sendEmail.$model"
              class="hidden"
              type="radio"
              id="can_go_ahead_no"
              value="1"
            />
            <div class="text-left">
              <div class="option-label">Lasciaci i tuoi contatti</div>
              <div class="option-detail">
                Ti rincontatteremo il prima possibile per un appuntamento
                gratuito con uno dei nostri nutrizionisti.
              </div>
            </div>
          </label>
        </div>
        <div v-if="$v.sendEmail.$error" class="error">
          campo obbligatorio
        </div>
      </div>

      <div v-if="showInputDisease">
        <div class="form-group">
          <br />
          <label class="form-label">Dicci cos'ha</label>
          <textarea
            v-model="$v.dog.disease.$model"
            class="form-control"
            id="disease"
            rows="3"
          ></textarea>
          <div v-if="$v.dog.disease.$error" class="error">
            campo obbligatorio
          </div>
        </div>
        <div class="form-group">
          <label class="form-label" for="phone_number"
            >Inserisci il tuo numero di telefono</label
          >
          <input
            v-model="$v.form.phoneNumber.$model"
            type="text"
            placeholder="Inserisci il tuo numero"
            class="form-control"
            id="phone_number"
          />
          <div v-if="!$v.form.phoneNumber.numeric" class="error">
            si prega di indicare un numero valido senza spazio
          </div>
          <div v-else-if="!$v.form.phoneNumber.itPhoneNumber" class="error">
            inserire un numero telefonico corretto, es: "02123456" oppure
            "3401234567"
          </div>
          <div v-else-if="$v.form.phoneNumber.$error" class="error">
            campo obbligatorio
          </div>
        </div>
      </div>

      <div v-if="dog.healthy == 1 || sendEmail == 0">
        <div class="form-group">
          <label class="form-label important-label">
            {{ dogData.name | capitalize }} è allergico o intollerante a qualche
            ingrediente?
          </label>
          <div class="options-container mb-5">
            <label
              class="option-tag"
              :class="[
                dog.allergyIds.includes(ingredient.id)
                  ? 'checked'
                  : 'unchecked',
              ]"
              v-for="ingredient in ingredients"
              :for="ingredient.id"
              :key="ingredient.id"
            >
              <input
                type="checkbox"
                class="hidden"
                :id="ingredient.id"
                :value="ingredient.id"
                v-model.number="$v.dog.allergyIds.$model"
              />
              <span>{{ ingredient.name }}</span>
            </label>
          </div>
          <label
            class="option-tag"
            :class="[!dog.hasAllergyOther ? 'unchecked' : 'checked']"
            for="other"
          >
            <input
              type="checkbox"
              class="hidden"
              id="other"
              v-model="dog.hasAllergyOther"
            />
            <span>Altro</span>
          </label>
          <div v-if="$v.dog.allergyIds.$error" class="error">
            campo obbligatorio
          </div>
        </div>

        <div class="form-group mt-10" v-if="dog.hasAllergyOther">
          <label class="form-label" for="allergy_other"
            >Per favore indica le allergie in questo campo</label
          >
          <input
            v-model="$v.dog.otherFoodAllergies.$model"
            type="text"
            placeholder=""
            class="form-control"
            id="allergy_other"
          />
          <div v-if="$v.dog.otherFoodAllergies.$error" class="error">
            campo obbligatorio
          </div>
        </div>
        <p class="mt-5">
          Te lo chiediamo per far in modo che abbia la pappa più adatta a
          {{ sex == 1 ? "lui" : "lei" }}.<br />
          Ricorda che la nostra pappa è completamente priva di coloranti e
          conservanti!
        </p>
      </div>
    </form>
  </div>
</template>

<script>
  import { required, requiredIf, or } from "vuelidate/lib/validators";
  import Multiselect from "vue-multiselect";
  import { customValidators } from "../constants.js";

  export default {
    components: {
      Multiselect,
    },
    props: {
      wizardData: {
        type: Object,
        required: true,
      },
      dogData: {
        type: Object,
        required: true,
      },
      listData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        sex: null,
        sendEmail: null,
        form: {
          phoneNumber: this.wizardData.phoneNumber,
        },
        dog: {
          healthy: null,
          disease: "",
          allergyIds: [],
          hasAllergyOther: 0,
          otherFoodAllergies: null,
        },
        ingredients: this.listData.ingredients,
        recipes: [],
      };
    },
    validations: {
      sendEmail: {
        required: requiredIf(function() {
          return this.showNotHealthy;
        }),
      },
      dog: {
        healthy: {
          required,
        },
        disease: {
          required: requiredIf(function() {
            return this.showInputDisease;
          }),
        },
        allergyIds: {
          // required
        },
        otherFoodAllergies: {
          required: requiredIf(function() {
            return this.dog.hasAllergyOther;
          }),
        },
      },
      form: {
        phoneNumber: {
          required: requiredIf(function() {
            return this.showInputDisease;
          }),
          numeric: requiredIf(function() {
            return this.showInputDisease;
          }),
          itPhoneNumber: or(
            customValidators.italianPhoneNumber,
            customValidators.italianMobileNumber
          ),
        },
      },
    },
    watch: {
      "dog.healthy": function() {
        if (this.dog.healthy == 1) {
          this.resetForm();
          this.sendEmail = null;
        }
      },
      sendEmail: function(value) {
        if (value == 0) {
          this.resetForm();
        }
      },
      "dog.allergyIds": function() {
        if (this.dog.allergyIds.includes(null)) {
          this.dog.allergyIds = [];
        }
        // this.checkRecipes()
      },
    },
    computed: {
      showNotHealthy: function() {
        return this.dog.healthy == 0;
      },
      showInputDisease: function() {
        return this.showNotHealthy && this.sendEmail == 1;
      },
    },
    methods: {
      resetForm() {
        this.dog.disease = "";
        // this.form.phoneNumber = null;
        this.$v.$reset();
      },
      submit() {
        this.$v.$touch();
        return new Promise((resolve, reject) => {
          if (!this.$v.$invalid) {
            resolve({
              form: {
                phoneNumber: this.form.phoneNumber,
              },
              dog: {
                healthy: this.dog.healthy,
                disease: this.dog.disease,
                allergyIds: this.dog.allergyIds,
                otherFoodAllergies: this.dog.otherFoodAllergies,
              },
            });
          } else {
            reject("invalid entry");
          }
        });
      },
    },
    activated() {
      this.sex = this.dogData.sex;
      this.dog.healthy = this.dogData.healthy;
      this.dog.disease = this.dogData.disease;
      this.form.phoneNumber = this.wizardData.phoneNumber;
      this.dog.allergyIds = this.dogData.allergyIds;
      if (this.dogData.otherFoodAllergies) {
        this.dog.hasAllergyOther = 1;
      } else {
        this.dog.hasAllergyOther = 0;
      }
      this.dog.otherFoodAllergies = this.dogData.otherFoodAllergies;

      this.$v.$reset();
    },
  };
</script>
